import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import CustomNavbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../seo/pages";
import usePresentations from "../hooks/usePresentations";

const InvestorsPage = () => {
    const { hash } = useLocation();
    const [corporateData, setCorporateData] = useState(null);
    const { presentationUrl, miningForumUrl } = usePresentations();

    useEffect(() => {
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                const yOffset = -120;
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }
    }, [hash]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('https://qgold-n8n.off-chainventures.com/webhook/2c3542bc-7bcc-47b8-a527-3909b9e7c29d');
                const data = await response.json();
                
                // Handle both array (if API changes back) and object responses
                const sourceData = Array.isArray(data) && data.length > 0 ? data[0] : data;
                
                if (sourceData) {
                    setCorporateData({
                        commonShares: sourceData.common || sourceData.commonShares,
                        optionsOS: sourceData.options || sourceData.optionsOS,
                        warrantsOS: sourceData.warrants || sourceData.warrantsOS,
                        diluted: sourceData.diluted,
                        marketCap: sourceData.mcap || sourceData.marketCap
                    });
                }
            } catch (error) {
                console.error("Error fetching corporate data:", error);
            }
        };

        fetchData();
    }, []);

    const formatNumber = (num) => {
        if (num === undefined || num === null) return "-";
        return num.toLocaleString();
    };

    const formatMarketCap = (num) => {
        if (num === undefined || num === null) return "-";
        const millions = Math.round(num / 1000000);
        return `$${millions}M`;
    };

    return (
        <div>
            <Seo {...PAGE_SEO.investors} />
            <CustomNavbar />
            <section className="investor-page">
                <section className="investor-page-banner text-center text-white"
                    style={{ backgroundImage: "url('/images/investor-banner.png')" }}>
                    <h2>Investors</h2>
                </section>
                <section className="investor-page-content">
                    <Container>
                        <h3 className="pt-5 mb-0">WHY INVEST IN Q-GOLD?</h3>
                        <h4 className="pb-3">A Dual-Asset Gold Platform Positioned for Significant Growth and Domestic
                            Production</h4>

                        {/* <ul>
                            <li className="shadow-lg p-4  rouded-3 bg-white flex items-start gap-3">
                                <img src="/images/arrow.svg" alt="arrow" />
                                <p>
                                    <b>Transformational U.S. Gold Acquisition</b> — Q-Gold has acquired the 1.543Moz
                                    Quartz
                                    Mountain project from Alamos Gold, who is retaining a 9% stake, validating the
                                    asset’s potential and aligning long-term interests.
                                </p>
                            </li>

                            <li className="shadow-lg p-4   bg-white flex items-start gap-3">
                                <img src="/images/arrow.svg" alt="arrow" />
                                <p>
                                    <b>100,000m+ Historic Drilling </b> — Extensive past drilling across the project
                                    provides a
                                    de-risked foundation for resource growth and near-term development.
                                </p>
                            </li>

                            <li className="shadow-lg p-4   bg-white flex items-start gap-3">
                                <img src="/images/arrow.svg" alt="arrow" />
                                <p>
                                    <b> 1.54 Moz Gold Resource </b>— 1.543 Moz M&amp;I @ 0.96 g/t + .15 Moz Inferred @ 0.77
                                    g/t with
                                    strong oxide recoveries (70–90%) amenable to heap-leaching.
                                </p>
                            </li>

                            <li className="shadow-lg p-4   bg-white flex items-start gap-3">
                                <img src="/images/arrow.svg" alt="arrow" />
                                <p>
                                    <b>Tier-One Jurisdiction</b> — Located in a mining-friendly county in Oregon,
                                    covering
                                    244 claims (~2,000 ha) with federally owned surface and mineral rights.
                                </p>
                            </li>

                            <li className="shadow-lg  p-4  bg-white flex items-start gap-3">
                                <img src="/images/arrow.svg" alt="arrow" />
                                <p>
                                    <b>Angel’s Camp Exploration Upside</b> — Historic intercepts of 2.85 g/t over 45.7m
                                    suggest
                                    the potential for a second major gold zone.
                                </p>
                            </li>

                            <li className="shadow-lg p-4   bg-white flex items-start gap-3">
                                <img src="/images/arrow.svg" alt="arrow" />
                                <p>
                                    <b>Permitted &amp; Funded Ontario Drill Program</b> — 2025 diamond drilling at Mine
                                    Centre
                                    targets a high-grade NI 43-101 resource near the historic Foley Shaft.
                                </p>
                            </li>
                        </ul> */}

                        <div className="investor-infographic text-center p-4 p-md-5 mx-auto my-5" style={{ backgroundColor: '#05244d', color: '#fff', borderRadius: '12px', maxWidth: '1000px', boxShadow: '0 12px 32px rgba(0,0,0,0.2)' }}>
                            <div className="mx-auto" style={{ maxWidth: '800px' }}>
                                <img src="/images/logo.png" alt="Q-Gold" style={{ height: '40px', objectFit: 'contain' }} className="mb-3" />

                                <h6 className="mb-2" style={{ color: '#f5c845', fontWeight: '500', letterSpacing: '0.5px' }}>Preliminary Economic Assessment (2026)</h6>
                                <h3 className="fw-bold mb-3" style={{ fontSize: '1.8rem' }}>Quartz Mountain Project<br /> Oregon, USA</h3>                            

                                <hr className="mx-auto" style={{ borderColor: '#f5c845', borderWidth: '2px', opacity: 1, width: '80%' }} />

                            <Row className="my-4">
                                <Col xs={6} className="d-flex flex-column justify-content-between h-100">
                                    <div style={{ color: '#f5c845', fontSize: '0.85rem', fontWeight: '700', letterSpacing: '0.5px' }}>AFTER TAX NPV(5%)*</div>
                                    <div className="fw-bold mt-2" style={{ color: '#f5c845', fontSize: 'clamp(2rem, 5vw, 3rem)', lineHeight: '1' }}>$1.7B</div>
                                </Col>
                                <Col xs={6} className="d-flex flex-column justify-content-between h-100 border-start" style={{ borderColor: 'rgba(245, 200, 69, 0.3) !important' }}>
                                    <div style={{ color: '#f5c845', fontSize: '0.85rem', fontWeight: '700', letterSpacing: '0.5px' }}>AFTER TAX NPV(5%)**</div>
                                    <div className="fw-bold mt-2" style={{ color: '#f5c845', fontSize: 'clamp(2rem, 5vw, 3rem)', lineHeight: '1' }}>$3.2B</div>
                                </Col>
                            </Row>

                            <div className="my-5 p-4 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)' }}>
                                <div style={{ fontSize: '0.85rem', fontWeight: '700', letterSpacing: '1px', color: 'rgba(255, 255, 255, 0.7)' }}>AVERAGE PRODUCTION PER YEAR</div>
                                <div className="fw-bold mt-2 mb-2" style={{ color: '#f5c845', fontSize: 'clamp(2.5rem, 6vw, 3.5rem)', lineHeight: '1' }}>135K <span style={{fontSize: '1.5rem', fontWeight: '500'}}>oz</span></div>
                                <div className="d-inline-block px-3 py-1 rounded-pill" style={{ fontSize: '0.75rem', backgroundColor: 'rgba(245, 200, 69, 0.1)', color: '#f5c845' }}>
                                    Life of Mine Production 1.9M oz | 166K oz Peak
                                </div>
                            </div>

                            <hr className="mx-auto" style={{ borderColor: '#f5c845', borderWidth: '1px', opacity: 0.3, width: '100%' }} />

                            <div className="fw-bold fs-5 mb-3 mt-4" style={{ letterSpacing: '2px', color: 'rgba(255, 255, 255, 0.7)' }}>IRR</div>
                            <Row className="mb-4">
                                <Col xs={6} className="position-relative">
                                    <div className="fw-bold" style={{ color: '#f5c845', fontSize: 'clamp(2rem, 5vw, 3rem)', lineHeight: '1' }}>55%*</div>
                                    <div className="mt-2" style={{ fontSize: '0.85rem', opacity: 0.7 }}>Payback 1.8 Yrs</div>
                                </Col>
                                <Col xs={6} className="border-start" style={{ borderColor: 'rgba(245, 200, 69, 0.3) !important' }}>
                                    <div className="fw-bold" style={{ color: '#f5c845', fontSize: 'clamp(2rem, 5vw, 3rem)', lineHeight: '1' }}>93%**</div>
                                    <div className="mt-2" style={{ fontSize: '0.85rem', opacity: 0.7 }}>Payback 1.3 Yrs</div>
                                </Col>
                            </Row>

                            <hr className="mx-auto" style={{ borderColor: '#f5c845', borderWidth: '1px', opacity: 0.3, width: '100%' }} />

                            <Row className="my-5">
                                <Col xs={6} className="d-flex flex-column justify-content-center">
                                    <div style={{ fontSize: '0.85rem', fontWeight: '700', letterSpacing: '1px', color: 'rgba(255, 255, 255, 0.7)' }}>LIFE OF MINE</div>
                                    <div className="fw-bold mt-2" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', lineHeight: '1' }}>14 yrs</div>
                                </Col>
                                <Col xs={6} className="d-flex flex-column justify-content-center border-start" style={{ borderColor: 'rgba(245, 200, 69, 0.3) !important' }}>
                                    <div style={{ fontSize: '0.85rem', fontWeight: '700', letterSpacing: '1px', color: 'rgba(255, 255, 255, 0.7)' }}>INITIAL CAPEX</div>
                                    <div className="fw-bold mt-2" style={{ color: '#f5c845', fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', lineHeight: '1' }}>US $290M</div>
                                </Col>
                            </Row>

                            <hr className="mx-auto" style={{ borderColor: '#f5c845', borderWidth: '1px', opacity: 0.3, width: '100%' }} />

                            <div className="my-5">
                                <div className="d-inline-block px-3 py-1 rounded-pill mb-4" style={{ fontSize: '0.75rem', fontWeight: '700', letterSpacing: '1px', backgroundColor: 'rgba(255, 255, 255, 0.1)' }}>NI 43-101 RESOURCE (2026)</div>
                                <Row>
                                    <Col md={6} className="mb-4 mb-md-0">
                                        <div className="p-3 rounded h-100" style={{ backgroundColor: 'rgba(245, 200, 69, 0.05)', border: '1px solid rgba(245, 200, 69, 0.2)' }}>
                                            <div className="fw-bold" style={{ color: '#f5c845', fontSize: '1.2rem', lineHeight: '1.4' }}>
                                                2.010 MILLION OUNCES<br/>GOLD IN INDICATED
                                            </div>
                                            <div className="mt-2" style={{ fontSize: '0.9rem', opacity: 0.8 }}>@ 0.78 G/T</div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="p-3 rounded h-100" style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
                                            <div className="fw-bold" style={{ color: '#fff', fontSize: '1.2rem', lineHeight: '1.4' }}>
                                                0.494 MILLION OZ AU<br/>IN INFERRED RESOURCE
                                            </div>
                                            <div className="mt-2" style={{ fontSize: '0.9rem', opacity: 0.8 }}>@ 0.80 G/T</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                                <div className="mt-5 text-start d-flex justify-content-center">
                                    <div>
                                        <div className="fw-bold text-center mb-3" style={{ fontSize: '0.85rem', letterSpacing: '1px' }}>STRATEGIC ADVANTAGES</div>
                                        <ul className="mb-4" style={{ fontSize: '0.85rem', paddingLeft: '20px', lineHeight: '1.8' }}>
                                            <li>Strong free cash flow potential</li>
                                            <li>Significant exploration upside</li>
                                            <li>Favourable jurisdiction with existing infrastructure</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="text-start mt-4 pt-3 border-top border-secondary opacity-75">
                                    <div style={{ fontSize: '0.75rem', color: '#f5c845' }}>
                                        <div>*US$3,265</div>
                                        <div>**US$4,820</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section className="investor-presentations" aria-labelledby="investor-presentations-heading">
                            <h3 id="investor-presentations-heading">Investor Presentations</h3>
                            <Row className="g-4">
                                <Col md={6}>
                                    <a
                                        className="investor-presentation-card"
                                        href={presentationUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span className="investor-presentation-card__icon" aria-hidden="true">
                                            <i className="fas fa-file-pdf" />
                                        </span>
                                        <span className="investor-presentation-card__body">
                                            <span className="investor-presentation-card__title">Corporate Presentation</span>
                                            <span className="investor-presentation-card__action">View PDF</span>
                                        </span>
                                    </a>
                                </Col>
                                <Col md={6}>
                                    <a
                                        className="investor-presentation-card"
                                        href={miningForumUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span className="investor-presentation-card__icon" aria-hidden="true">
                                            <i className="fas fa-file-pdf" />
                                        </span>
                                        <span className="investor-presentation-card__body">
                                            <span className="investor-presentation-card__title">
                                                Mining Forum Americas Presentation
                                                <span className="investor-presentation-card__date">September 2026</span>
                                            </span>
                                            <span className="investor-presentation-card__action">View PDF</span>
                                        </span>
                                    </a>
                                </Col>
                            </Row>
                        </section>

                        <Row className=" mt-5 pt-3" id="company-filings">
                            <Col md={9}>
                                <iframe
                                    title="symbol overview TradingView widget"
                                    lang="en"
                                    id="tradingview_qgr"
                                    frameBorder="0"
                                    allowTransparency="true"
                                    scrolling="no"
                                    style={{ width: "100%", height: "300px" }}
                                    src="https://s.tradingview.com/embed-widget/symbol-overview/?locale=en#%7B%22symbols%22%3A%5B%5B%22TSXV%22%2C%22TSXV%3AQGR%7C12M%22%5D%5D%2C%22width%22%3A%221000px%22%2C%22height%22%3A%22400px%22%2C%22colorTheme%22%3A%22light%22%2C%22gridLineColor%22%3A%22rgba(46%2C%2046%2C%2046%2C%200.06)%22%2C%22fontColor%22%3A%22%23000000%22%2C%22chartType%22%3A%22area%22%2C%22lineColor%22%3A%22%23d2b521%22%2C%22topColor%22%3A%22%23d2b521%22%2C%22bottomColor%22%3A%22%23d2b521%22%2C%22isTransparent%22%3Afalse%2C%22autosize%22%3Atrue%2C%22utm_source%22%3A%22yourwebsite.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22symbol-overview%22%7D"
                                />
                            </Col>
                            <Col md={3}>
                                <div className="box-company">
                                    <h4>Company Filings</h4>
                                    <p>You can find all our company filings on SEDAR+</p>
                                    <a href="https://www.sedarplus.ca/csa-party/viewInstance/view.html?id=0c11f8b7998bcd96786b7e0dded6dcf24db31effb38d6408" target="_blank">Visit SEDAR+</a>
                                </div>
                            </Col>
                        </Row>

                        {/* <div className="investor-page-table">
                            <Row className="pb-md-5">
                                <Col md={12} style={{ overflow: 'auto' }}>
                                    <img src="/images/investor-page-image-2.png" alt="investor-page-image" />
                                </Col>
                            </Row>
                        </div> */}
                        <div className="investor-page-table">
                            <Row className="pb-md-5">
                                <Col md={12}>
                                    <section className="corporate-overview">
                                        <h5 className="co-title">Corporate Overview</h5>
                                        <p className="co-subtitle">Share Structure</p>

                                        {/* Top cards */}
                                        <Row className="g-4 mt-3">
                                            <Col md={3} sm={6}>
                                                <div className="co-card">
                                                    <div className="co-card-number">{corporateData ? formatNumber(corporateData.commonShares) : "Loading..."}</div>
                                                    <p className="co-card-label">Common shares o/s</p>
                                                </div>
                                            </Col>

                                            <Col md={3} sm={6}>
                                                <div className="co-card">
                                                    <div className="co-card-number">{corporateData ? formatNumber(corporateData.optionsOS) : "Loading..."}</div>
                                                    <p className="co-card-label">
                                                        Options o/s
                                                        <span className="co-card-sub">
                                                            (weighted ave, ex, $0.07)
                                                        </span>
                                                    </p>
                                                </div>
                                            </Col>

                                            <Col md={3} sm={6}>
                                                <div className="co-card">
                                                    <div className="co-card-number">{corporateData ? formatNumber(corporateData.warrantsOS) : "Loading..."}</div>
                                                    <p className="co-card-label">
                                                        Warrants o/s
                                                        <span className="co-card-sub">
                                                            (weighted ave, ex, $0.20)
                                                        </span>
                                                    </p>
                                                </div>
                                            </Col>

                                            <Col md={3} sm={6}>
                                                <div className="co-card">
                                                    <div className="co-card-number">{corporateData ? formatNumber(corporateData.diluted) : "Loading..."}</div>
                                                    <p className="co-card-label">Fully diluted</p>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Bottom row */}
                                        <Row className="g-4 mt-4 align-items-stretch">
                                            <Col md={4} lg={3}>
                                                <div className="co-mcap-card">
                                                    <p className="co-mcap-label">
                                                        Market<br />Capitalization
                                                    </p>
                                                    <p className="co-mcap-value">{corporateData ? formatMarketCap(corporateData.marketCap) : "Loading..."}</p>
                                                </div>
                                            </Col>

                                            <Col md={8} lg={9}>
                                                <div className="co-listing-card">
                                                    <div className="co-listing-logos">
                                                        {/* yahan ap apne actual logo images laga sakte ho */}
                                                        <img src="/images/tmx-logo.png" alt="TMX" />
                                                        <img
                                                            src="/images/tsx-venture-logo.png"
                                                            alt="TSX Venture Exchange"
                                                        />
                                                        <img src="/images/otcqx-logo.png" alt="OTCQX" />
                                                        <img
                                                            src="/images/applied-logo.png"
                                                            alt="Applied"
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </section>
                                </Col>
                            </Row>
                        </div>

                        <h4></h4>
                    </Container>
                </section>
            </section>
            <Footer />
        </div>
    );
};

export default InvestorsPage;
